const NotResults = ({ meeting }) => (
  <div className='max-w-screen-xl mt-24 px-8 xl:px-16 mx-auto'>
    <div className='grid grid-flow-row sm:grid-flow-col grid-rows-2 md:grid-rows-1 sm:grid-cols-2 gap-8 py-6 sm:py-16' />
    <div className='mt-4 mb-5'>
      <div className='list-container'>
        <div className='list-items flex flex-col sm:flex-row items-center justify-between max-w-2xl mx-auto border-2 border-gray-500 hover:border-green-500 rounded-md my-1 px-5 py-5'>
          <div className='flex flex-row items-center space-x-5'>
            <h1 className='tracking-tight dark:text-gray-100'>
              ¡La reunión con id {meeting} no existe!
            </h1>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default NotResults;
